import * as type from '../actions/types';

const initialState = {
  data: null,
  fetching: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_ALL_POS_SYSTEMS_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
      };

    case type.FETCH_ALL_POS_SYSTEMS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload.data,
        success: true,
        error: false,
      };

    case type.FETCH_ALL_POS_SYSTEMS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };

    default:
      return state;
  }
};
